import React, { useEffect } from "react";
import {
	Button,
	Listbox,
	ListboxItem,
	Modal,
	ModalBody,
	ModalContent,
	ModalHeader,
} from "@heroui/react";
import LiveStatisticCard from "../components/LiveStatisticCard";
import LiveStatisticWidget from "../components/widget/LiveStatisticWidget";

function DashboardPage(props) {
	const [widgets, setWidgets] = React.useState([]);
	const [inAdd, setAdd] = React.useState(false);
	const [state, setState] = React.useState([]);
	useEffect(() => {
		var ref = setInterval(() => {
			if (widgets.length > 0 && document.visibilityState === "visible") {
				axios
					.post("/api/widget/refresh", {
						items: widgets,
					})
					.then((res) => {
						setState(res.data.items);
					});
			}
		}, 2500);
		return () => {
			clearInterval(ref);
		};
	}, [widgets]);
	return (
		<div>
			<WidgetsList
				isOpen={inAdd}
				onClose={() => setAdd(false)}
				onAdd={(e) => {
					setWidgets((prev) => [
						...prev,
						{
							type: "live-card",
							id: crypto.randomUUID(),
							uid: 1789460279,
						},
					]);
				}}
			/>
			<Button
				onClick={() => {
					setAdd(true);
				}}
			>
				Add
			</Button>
			{widgets.map((widget, index) => (
				<React.Fragment key={widget.id || index}>
					{(() => {
						if (widget.type === "live-card") {
							var s = state?.filter(
								(item) => item.UserID === widget.uid + "",
							)?.[0];
							return (
								<LiveStatisticWidget
									{...s}
									onAnchorSelect={(e) => {
										setWidgets((prev) => [
											...prev.filter(
												(item) => item.id !== widget.id,
											),
											{
												type: "live-card",
												id: widget.id,
												uid: parseInt(e),
											},
										]);
									}}
									onAnchorRemove={() => {
										setWidgets((prev) => [
											...prev.filter(
												(item) => item.id !== widget.id,
											),
										]);
									}}
									onClick={() => {
										open("/lives/" + s.ID);
									}}
								/>
							);
						}
					})()}
				</React.Fragment>
			))}
		</div>
	);
}
function WidgetsList({ isOpen, onClose, onAdd }) {
	return (
		<Modal isOpen={isOpen} onClose={onClose}>
			<ModalContent>
				<ModalHeader>添加Widget</ModalHeader>
				<ModalBody>
					<Listbox variant={"flat"}>
						<ListboxItem
							onClick={(e) => {
								e.stopPropagation();
								onAdd({
									type: "live-card",
								});
							}}
						>
							<p className={"mb-1.5"}>
								直播场次卡片，展示传入UID的最新一场直播
							</p>
							<LiveStatisticCard
								showUser={true}
								item={{
									UserID: 3537119901387660,
									UserName: "红魔姬Mora",
									Money: 1145.14,
									Message: 2434,
									CreatedAt: new Date("2022-05-10"),
									Title: "歌杂歌杂~！",
									Cover: "https://i0.hdslb.com/bfs/live/new_room_cover/92093daa88300d01b39b55247a44284a36a61653.jpg",
								}}
							/>
						</ListboxItem>
					</Listbox>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}
export default DashboardPage;
